import api from '@/lib/api';

export async function fetchAdminMe() {
  const { data } = await api.get('/admin/me');
  return data;
}

export async function fetchAdminCollections() {
  const { data } = await api.get('/admin/collections');
  return data;
}

export async function fetchAdminDocuments(collection, { page = 1, pageSize = 25, q = '' } = {}) {
  const { data } = await api.get(`/admin/collections/${collection}`, {
    params: { page, page_size: pageSize, q: q || undefined },
  });
  return data;
}

export async function fetchAdminDocument(collection, docId) {
  const { data } = await api.get(`/admin/collections/${collection}/${encodeURIComponent(docId)}`);
  return data;
}

export async function createAdminDocument(collection, document) {
  const { data } = await api.post(`/admin/collections/${collection}`, { document });
  return data;
}

export async function updateAdminDocument(collection, docId, document) {
  const { data } = await api.patch(`/admin/collections/${collection}/${encodeURIComponent(docId)}`, {
    document,
  });
  return data;
}

export async function searchStoryJourneys(q = '') {
  const { data } = await api.get('/admin/story-journeys', {
    params: { q: q || undefined },
  });
  return data;
}

export async function fetchStoryJourney(kind, subjectId) {
  const { data } = await api.get(
    `/admin/story-journeys/${encodeURIComponent(kind)}/${encodeURIComponent(subjectId)}`,
  );
  return data;
}

export async function fetchCustomerJourneyOverview(days = 7) {
  const { data } = await api.get('/admin/customer-journey/overview', { params: { days } });
  return data;
}

export async function searchCustomerJourneyUsers(q = '') {
  const { data } = await api.get('/admin/customer-journey/users', {
    params: { q: q || undefined },
  });
  return data;
}

export async function fetchCustomerJourney(userId) {
  const { data } = await api.get(`/admin/customer-journey/users/${encodeURIComponent(userId)}`);
  return data;
}

export async function fetchPipelineAudit({ page = 1, pageSize = 25, kind = '', q = '' } = {}) {
  const { data } = await api.get('/admin/pipeline-audit', {
    params: {
      page,
      page_size: pageSize,
      kind: kind || undefined,
      q: q || undefined,
    },
  });
  return data;
}

export async function deleteAdminDocument(collection, docId) {
  const { data } = await api.delete(
    `/admin/collections/${collection}/${encodeURIComponent(docId)}`,
  );
  return data;
}

export function isStaffRole(role) {
  return role === 'admin' || role === 'moderator';
}

/** True when user may open the admin dashboard (role or server-granted read permission). */
export function canAccessAdmin(profile) {
  if (!profile || typeof profile !== 'object') return false;
  if (isStaffRole(profile.role)) return true;
  return Boolean(profile.permissions?.read);
}

export function readStoredUserProfile() {
  try {
    return JSON.parse(localStorage.getItem('storycraft_user') || '{}');
  } catch {
    return {};
  }
}

export function storeUserProfile(patch) {
  const prev = readStoredUserProfile();
  localStorage.setItem('storycraft_user', JSON.stringify({ ...prev, ...patch }));
}

export const AUTH_CHANGED_EVENT = 'storycraft-auth-changed';
